import { PdfGen } from '../pdf/pdf';
import { OptsSingle } from './optsSingle';

export const ILayoutSingleSymbol = Symbol('LayoutSingle');

export interface ILayoutSingleGen {
  generate(pdf: PdfGen, opts: OptsSingle): Promise<void>;
}
